@if (isTypeStar) {
<div class="stars" role="radiogroup">
  @for (point of points; track point) {
  <div>
    <button
      role="radio"
      (mouseenter)="fill(point)"
      (mouseleave)="empty()"
      (click)="rate(point)"
      [class.star-rate]="isActive(point)"
      [class.star-dark]="isDarkMode()"
      [attr.aria-checked]="item().rating === point"
      class="star"
      [attr.data-tid]="'survey/answer/score/' + point"
    ></button>
  </div>
  }
</div>
} @if (!isTypeStar) {
<div class="fx-column fx-gap-xs">
  <div class="fx-row fx-align-center fx-justify-space-between">
    <small class="text-muted" translate>Not likely</small>
    <small class="text-muted" translate>Very likely</small>
  </div>
  <div class="radios" role="radiogroup">
    @for (point of points; track point) {
    <label [class.active]="item().rating === point">
      <input
        required
        type="radio"
        name="{{ question().id }}"
        [value]="i"
        (change)="rate(point)"
        [attr.data-tid]="'survey/answer/score/' + point"
      />
      <span>{{ point }}</span>
    </label>
    }
  </div>
</div>
} @if (isError()) {
<div class="form-error" translate>Required</div>
}
